<template>
  <div class="dashboard">
    <!-- 欢迎卡片（浅色明亮渐变） -->
    <div class="welcome-card">
      <div class="welcome-content">
        <h1>欢迎回来，{{ adminName }}</h1>
        <p>今天又是充满活力的一天，让我们一起管理好额度吧！</p>
      </div>
      <div class="welcome-icon">
        <i class="fas fa-shield-alt"></i>
      </div>
    </div>

    <!-- 统计卡片网格 -->
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-file-alt"></i>
        </div>
        <div class="stat-info">
          <h3>表单总数</h3>
          <p>{{ formCount }}</p>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-qrcode"></i>
        </div>
        <div class="stat-info">
          <h3>二维码数量</h3>
          <p>{{ qrCount }}</p>
        </div>
      </div>

      <div class="stat-card">
        <div class="stat-icon">
          <i class="fas fa-calendar-check"></i>
        </div>
        <div class="stat-info">
          <h3>还款期数</h3>
          <p>{{ periodCount }}</p>
        </div>
      </div>
    </div>

    <!-- 快捷操作 -->
    <div class="quick-actions">
      <h3>快捷操作</h3>
      <div class="action-buttons">
        <router-link to="/form" class="action-btn">
          <i class="fas fa-plus-circle"></i>
          <span>新增表单</span>
        </router-link>
        <router-link to="/qrcode" class="action-btn">
          <i class="fas fa-qrcode"></i>
          <span>生成二维码</span>
        </router-link>
        <router-link to="/industry-position" class="action-btn">
          <i class="fas fa-briefcase"></i>
          <span>管理行业</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/axios'

const adminName = ref('管理员')
const formCount = ref(0)
const qrCount = ref(0)
const periodCount = ref(0)

onMounted(async () => {
  try {
    const [formsRes, qrRes, periodsRes] = await Promise.all([
      axios.get('/details'),
      axios.get('/qr'),
      axios.get('/repayment_periods')
    ])
    formCount.value = formsRes.data?.length || 0
    qrCount.value = qrRes.data?.length || 0
    periodCount.value = periodsRes.data?.length || 0
  } catch (error) {
    console.error('获取统计数据失败:', error)
  }
})
</script>

<style scoped>
.dashboard {
  padding: 24px 32px;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #f5f7fc 0%, #eef2f8 100%);
  min-height: 100vh;
  color: #1a2634;
}

/* 欢迎卡片 - 渐变风格，与整体协调 */
.welcome-card {
  background: linear-gradient(135deg, #2c3e50 0%, #1e2a36 100%);
  border-radius: 28px;
  padding: 32px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  color: white;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.welcome-content h1 {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: -0.01em;
}

.welcome-content p {
  font-size: 0.95rem;
  opacity: 0.9;
  line-height: 1.5;
}

.welcome-icon i {
  font-size: 80px;
  opacity: 0.2;
  color: #ffffff;
}

/* 统计卡片网格 - 白色卡片 */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

.stat-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
  border: 1px solid #e9f0f3;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 30px rgba(44, 62, 80, 0.08);
  border-color: #dce5ec;
}

.stat-icon {
  width: 64px;
  height: 64px;
  background: #f8fbfd;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s;
}

.stat-icon i {
  font-size: 32px;
  color: #2c3e50;
}

.stat-info h3 {
  font-size: 0.85rem;
  font-weight: 500;
  color: #5b6e8c;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

.stat-info p {
  font-size: 2rem;
  font-weight: 700;
  color: #1a2634;
  letter-spacing: -0.01em;
}

/* 快捷操作区域 */
.quick-actions h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a2634;
  margin-bottom: 20px;
  padding-left: 4px;
}

.action-buttons {
  display: flex;
  gap: 18px;
  flex-wrap: wrap;
}

.action-btn {
  background: white;
  border: 1px solid #e2edf2;
  border-radius: 20px;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
  color: #1a2634;
  font-weight: 500;
  font-size: 0.95rem;
  transition: all 0.25s ease;
  flex: 1;
  min-width: 180px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
}

.action-btn:hover {
  border-color: #cbdde6;
  transform: translateY(-3px);
  box-shadow: 0 12px 24px rgba(44, 62, 80, 0.08);
  background: #ffffff;
}

.action-btn i {
  font-size: 1.6rem;
  color: #2c3e50;
}

/* 手机端适配 */
@media (max-width: 768px) {
  .dashboard {
    padding: 20px 16px;
  }

  .welcome-card {
    padding: 24px 20px;
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }

  .welcome-content h1 {
    font-size: 1.5rem;
  }

  .welcome-icon i {
    font-size: 64px;
  }

  .stats-grid {
    gap: 18px;
  }

  .stat-card {
    padding: 20px 18px;
  }

  .stat-info p {
    font-size: 1.8rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-btn {
    min-width: auto;
    justify-content: center;
  }
}
</style>